<div class="tm-not-found__image">
    <tg-svg aria-hidden="true" class="tm-not-found__svg">
        <tm-page-not-found-illustration></tm-page-not-found-illustration>
    </tg-svg>
</div>
<div class="l-container tm-not-found__container">
    <h1 class="p-h2">Oops! The page you requested was not found.</h1>
    <p>
        Perhaps you'd like to
        <a class="h-link-no-visited" href="{{ tradeMeUrl }}">
            go back to the home page?
        </a>
    </p>
</div>
